import { DatePipe } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from "lodash";
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';

@Component({
  selector: 'app-patdash',
  templateUrl: './patdash.component.html',
  styleUrls: ['./patdash.component.css']
})
export class PatdashComponent extends FormSessionCanDeactivate {
  temphoneOther: any;
  temphone: any;
  maxlen1: any;
  setlength1: any;
  setmask1: string;
  phoneOthervalue: boolean = false;
  shospital8: boolean;
  shospital7: boolean;
  qualifi: any;
  qualification: any;
  patdetails: any;
  patdetail: any = {};
  setmask: any;
  maxlen: any;
  setlength: any;
  bodysurgical: any[];
  reason: any = [];
  format: boolean;
  tempbodylaterality: any;
  enablepatdetailsstatus: boolean;
  enrollPatientId: any;
  enablestatus: boolean;
  mindate1: Date;
  enabletext: boolean;
  payortypechange: any;
  public msg: any = {
    title: '',
    comment: ''
  };
  payordata: any;
  payor: any;
  @ViewChild('scrollMe')
  shospital6: boolean;
  frac: boolean;
  disabled: boolean;
  side: boolean;
  dosvalue = ''
  showin: boolean = false;
  bodysideempty: boolean = false;
  public pay: any = {}
  public Totaldata: any = {}
  public bobMaxDate = new Date();
  public dosMaxDate = new Date(this.bobMaxDate.getTime())
  locatbody: any;
  dosStatus: boolean;
  dateform: any = environment.dateForm
  carepath: any;
  surgeonList: any;
  bodyside: any[];
  temp: boolean;
  addpart: any[];
  index: number;
  tempbodypart: any;
  bodyl: any;
  locat: any;
  public hiddenchecked: boolean = false;
  public showcross: boolean = false;
  shospital2: boolean;
  bodyparttype: boolean;
  bodyloc: any;
  bodypartCopy: any;
  user: any;
  hospitalList: any[];
  show: any;
  showph: any;
  payortype: any;
  maxdate: boolean;
  mindate: boolean;
  showinvaild1: boolean;
  shospital1: boolean;
  shospital3: boolean;
  shospital4: boolean;
  shospital5: boolean;
  disresult: any;
  imgMaxSize: any;
  public patientdetail: any = {
    ssn: '',
    mrnNo: '',
    bpci: 'No',
    PatientSWfId: '',
    code: '+1,USA'

  }
  Notes: any = 'Qualification';
  currentUser: User;
  uid: any
  modalRef: BsModalRef;
  modalRef1: BsModalRef;
  resp: string;
  respass: string;
  clienttype: string;
  public temMail: any;
  imagearr: { filename: any; filetype: any; value: any; };
  public temp_var: boolean = false;
  public showinvaild: boolean = false;
  public message: any;
  public codes: any = [];
  public alterNo: any = [];
  showloader: boolean = false;
  dataimg: any;
  public patientinfo: any = {};
  public payorinfo: any = {};
  public procedureinfo: any = {};
  fracs: boolean;
  public params: any = {
    status: false
  };
  public hospitalid: any;
  public patientStatus: any;
  myInputVariable: any;
  public datenew = new Date("01/01/1800");
  public patientUrl = './assets/img/users/addusericon.png'
  public defaultUl = './assets/img/users/addusericon.png'
  apiurl: any = environment.api_url;
  public timealert = environment.timelimit;
  dtOptions: any = {};
  patdata: any = {};
  status: boolean = false;
  emailcheck: boolean = false;
  mobile: boolean = false;
  public dateformat = environment.dateFormat;
  public bsConfig: any
  required: boolean = false;
  emailstatus: boolean;
  invited: boolean = false;
  edinvited: any;
  openpopup: boolean = false;
  patemail: boolean = false;
  patphone: boolean = false;
  isccn: boolean = false;
  isfcn: boolean = false;
  enableccn: boolean = true;
  enablefcn: boolean = true;
  validatemail: boolean = false;
  notesmsg: any;
  Qnote: any;
  tempphone: any;
  patdisqualifi: any = {};
  tempstage: any;
  qualificationId: any;
  stage: any;
  openNotes(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-md' });
    this.movable()
  }
  constructor(
    private patientservice: PatientService,
    private userService: UserService,
    private router: ActivatedRoute,
    private route: Router,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    private toast: ToastrService,
    private localeService: BsLocaleService
  ) {
    super();
    this.router.params.subscribe(params => {
      this.params = params
      this.stage = params['stage']
      this.qualificationId = params['qualification']
      // ////console.log(this.params.status)
    });
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
  }
  openConfirm(confirm: TemplateRef<any>, ed) {
    this.modalRef1 = this.modalService.show(confirm, { class: 'modal-md' });
    this.movable()
    this.edinvited = ed
    this.openpopup = true
  }
  public imageURL: string = environment.cloudeImageURL;
  ngOnInit() {
    this.dosMaxDate.setDate(this.dosMaxDate.getUTCDate() + 365);
    this.getbundlepayortype();
    this.userService.currentUser.subscribe(
      (userData) => {

        this.currentUser = userData;
        if (this.currentUser.item) {
          this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          if (this.currentUser.item.language != 'en_uk') {
            this.patientinfo.code = '+1,USA'
            this.patientinfo.codeOther = '+1,USA'
          } else if (this.currentUser.item.language == 'en_uk') {
            this.patientinfo.code = '+44,UK'
            this.patientinfo.codeOther = '+44,UK'
          }
          if (this.currentUser.item.clientTeleCode) {
            this.patientinfo.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
            this.patientinfo.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
          }
          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
            this.dateform = environment.dateForm
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
            this.dateform = 'dd/MM/yyyy'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
      }
    );


    this.clienttype = this.currentUser.item.clientType;
    this.hospitalid = this.currentUser.item.userAccountKey;
    if (this.currentUser.item.userrole == 'Care Navigator' || this.currentUser.item.userrole == 'Care Coordinator' || this.currentUser.item.userrole == 'Hospital Care Navigator' || this.currentUser.item.userrole == 'Commercial Care Navigator') {
      this.enablestatus = false;
    } else {
      this.enablestatus = true;
    }
    if (this.currentUser.item.userGroupId == 27) {
      this.isccn = true
      this.currentUser.item.userGroupId = 27
    }
    else if (this.currentUser.item.userGroupId == 28) {
      this.isfcn = true
      this.currentUser.item.userGroupId = 28
    }
    this.uid = this.currentUser.item.userAccountId;
    // ////console.log("id",this.currentUser)
    this.patientStatus = this.params.patstatus;

    let self = this;
    self.patientservice.getselcode(this.hospitalid)
      .subscribe(data => {
        self.codes = data

      })
    self.patientservice.getAlterNo()
      .subscribe(data => {
        self.alterNo = data
        this.patientinfo.otherPhoneType = 1
      })


    this.patientservice.getnewpatientinfo(this.params.patientId).subscribe(
      data => {
        if (this.qualificationId == 14 && this.stage == 5) {
          data.stageId = 5
          data.qualificationId = 14
        }
        this.patdetails = data
        this.tempstage = data.stageId
        this.qstage()
        if (this.patdetails.stageId % 2 != 0 && this.isccn) {
          this.enableccn = false
          this.enablefcn = true
        } else if (this.patdetails.stageId % 2 == 0 && this.isfcn) {
          this.enablefcn = false
          this.enableccn = true
        }
        this.patientinfo = data.profileData;
        this.temMail = this.patientinfo.email;
        this.tempphone = this.patientinfo.telNumber ? this.patientinfo.telNumber : '';
        if (this.enrollPatientId) {
          this.enablepatdetailsstatus = true
        }
        if (this.patientinfo.archived) {
          this.enablestatus = true
        }
        if (this.patientinfo.phoneOther)
          this.phoneOthervalue = true
        else
          this.phoneOthervalue = false
        this.payorinfo = data.payorData;
        this.procedureinfo = data.procedureData;
        this.fracs = data.procedureData.fracture;
        this.patientinfo.dob = new Date(this.patientinfo.dob)
        if (data.profileData.image.search("default_") == -1)
          this.dataimg = this.imageURL + data.profileData.image;
        else
          this.dataimg = this.defaultUl
        if (this.currentUser.item.clientTeleCode) {
          this.patientinfo.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
          this.patientinfo.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
        }
        if (this.patientinfo.telCode) {
          this.patientinfo.code = this.patientinfo.telCode + ',' + this.patientinfo.telCountryCode
        }
        if (this.patientinfo.telCodeOther) {
          this.patientinfo.codeOther = this.patientinfo.telCodeOther + ',' + this.patientinfo.telCountryCodeOther
        }
        this.temphone = this.patientinfo.telNumber ? this.patientinfo.telNumber : ''
        this.temphoneOther = this.patientinfo.phoneOther ? this.patientinfo.phoneOther : ''
        this.patientinfo.otherPhoneType = this.patientinfo.otherPhoneType ? this.patientinfo.otherPhoneType : 1
        this.checkphonelength(this.patientinfo.code)
        this.checkphonelength1(this.patientinfo.codeOther)
        if (this.procedureinfo.dos) {
          let date = this.datepipe.transform(this.procedureinfo.dos, 'yyyy-MM-dd');
          let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
          if (date < curentdate) {
            this.mindate1 = new Date(date)
          } else {
            this.mindate1 = new Date()
          }
        } else {
          this.mindate1 = new Date()
        }
        if (!this.procedureinfo.hospitalId) {
          this.procedureinfo.hospitalId = "100000"
        }
        if (!this.procedureinfo.surgeonId) {
          this.procedureinfo.surgeonId = "500000"
        }
        if (this.patientinfo.qualificationStatus == 'Not Medically qualified' || this.patientinfo.qualificationStatus == 'Not interested' || this.patientinfo.qualificationStatus == 'Defaulted' || this.patientinfo.qualificationStatus == 'Paid in Full') {
          this.enablestatus = true;
        }
        setTimeout(() => {
          const cnDropElement = document.getElementById("procedureTypedd") as HTMLSelectElement;
          if (cnDropElement) {
            cnDropElement.value = this.procedureinfo.procedureType;
          }

          const cnDropElement1 = document.getElementById("surgeonId") as HTMLSelectElement;
          if (cnDropElement1) {
            cnDropElement1.value = this.procedureinfo.surgeonId;
          }
        }, 1000);
        this.getBodyPart(this.procedureinfo.procedureType);
        this.getSurgeonNames();
        this.getHospitalLsit();
        this.reasonstage();
        this.QualificationNoteslist()
        this.getbundlepayortypeprocedure(this.payorinfo.bundlePayorTypeId)

      }
    );
  }

  qstage() {
    this.patientservice.getStageQualificationDetails(this.currentUser.item.userGroupId).subscribe(
      data => {
        this.qualification = data;
        if(data && data.length > 0 && data[0]['qualificationDataDisplayName'].length > 0) {
          this.qualification.map((ele,index) => {
            ele.qualificationData.map((element, subIndex) => {
              element['titleDisplayName'] = data[index]['qualificationDataDisplayName'].find(el=> el.qualificationId == element.qualificationId)['title'] || ''
            });
          })
        }
        console.log(this.qualification)
        this.getstage(this.patdetails.stageId)
      }
    );
  }

  getHospitalLsit() {
    let self = this;
    self.patientservice.getHospitalList(self.currentUser.item.userAccountId)
      .subscribe(data => {
        self.hospitalList = _.filter(data.aaData, (o) => {
          return o.hospitalId != 10001
        })
      })
  }
  getbundlepayortype() {
    this.patientservice.getbundletype().subscribe(data => {
      this.payordata = data
    })
  }
  getstage(event) {
    this.qualifi = ''
    event = parseInt(event)
    let index = _.findIndex(this.qualification, (o: any): any => {
      return o.stageId == event
    })
    this.patdetails.stageId = event
    this.qualifi = this.qualification[index].qualificationData
    if (event != this.tempstage) {
      this.patdetails.qualificationId = ""
      this.tempstage = ''
    }

  }
  getSurgeonNames() {

    let self = this;
    self.patientservice.getSurgeonlist(self.currentUser.item.userAccountId)
      .subscribe(data => {
        this.surgeonList = data;
        // ////console.log("Surgeon List", self.surgeonList)
        let index = _.findIndex(self.surgeonList, (o: any): any => {
          return o.firstName == this.patientinfo.SurgeonFirstName
        })

        if (index != -1) {
          this.procedureinfo.surgeon = self.surgeonList[index].surgeonId
          self.user.surgeonId = this.procedureinfo.surgeon
        }
      })
  }

  getBodyPart(location) {
    let self = this;
    self.patientservice.getBodyLocation(this.currentUser.item.userAccountKey)
      .subscribe(data => {
        this.bodyloc = data
        if (location == this.locatbody) {
          let index = _.findIndex(self.bodyloc.ServicelineLabel, (o: any): any => {
            return o.ServicelineLabel == this.procedureinfo.procedureType
          })

          if (index != -1) {
            this.locat = self.bodyloc.ServicelineLabel[index].Location
            this.locatbody = self.bodyloc.ServicelineLabel[index].SurgicalLocation
          }
          this.patientdetail.location = this.locat
          this.patientdetail.surgical = this.locatbody
          this.bodyl = this.procedureinfo.procedureType
          this.tempbodypart = this.bodyl
          // ////console.log(this.locat)
          // ////console.log(this.bodyl)
          this.showlist(this.procedureinfo.procedureType);

        }
        else {
          let index = _.findIndex(self.bodyloc.ServicelineLabel, (o: any): any => {
            return o.ServicelineLabel == this.procedureinfo.procedureType
          })

          if (index != -1) {
            this.locat = self.bodyloc.ServicelineLabel[index].Location
            this.locatbody = self.bodyloc.ServicelineLabel[index].SurgicalLocation
            this.procedureinfo.location = self.bodyloc.ServicelineLabel[index].Location
          }
          this.tempbodylaterality = self.procedureinfo.laterality
          this.locat = location
          this.bodyl = ''
          this.tempbodypart = this.bodyl
          this.showlist1(this.procedureinfo.procedureType, self.procedureinfo.laterality);
        }
      })


  }
  showlist1(bodypart, side) {
    if (bodypart == 'T-Spine')
      return this.bodyside = []
    else
      return this.bodyside = ['Left', 'Right']


  }
  showprocedure(event) {
    this.procedureinfo.surgicalLocation = this.procedureinfo.surgicalLocationDisplayName
    this.procedureinfo.procedureType = ''
    this.procedureinfo.laterality = ''
    this.getBodyPart(event)
  }
  showlist(bodypart) {
    let self = this
    let index = _.findIndex(self.bodyloc.ServicelineLabel, (o: any): any => {
      return o.ServicelineLabel == bodypart
    })

    if (index != -1) {
      this.procedureinfo.location = self.bodyloc.ServicelineLabel[index].Location
      this.procedureinfo.surgicalLocation = self.bodyloc.ServicelineLabel[index].SurgicalLocation
    }
    if (bodypart == 'Other') {
      this.procedureinfo.location = 'Other'
      this.procedureinfo.laterality = ''
    }
    if (bodypart == 'Partial Hip Replacement' || bodypart == 'Hip and Femur Fracture (SHFFT)') {
      this.fracs = true
      this.procedureinfo.fracture = true
    } else {
      this.fracs = false
      this.procedureinfo.fracture = false
    }
    if (this.enrollPatientId) {
      this.patientservice
        .getuserid(this.enrollPatientId)
        .subscribe(
          data => {
            this.temp_var = true;
            this.pay = data[0];
            ////console.log(data[0])
            if (Array.isArray(data) && data.length) {
              this.addpart = data;

              if (bodypart != '') {
                this.temp = true

                let f2 = this.addpart[0].allServiceLineLabel.split(',')
                let temarray = _.filter(f2, (o: any): any => {
                  return o.includes(bodypart)
                })
                if (temarray.length > 1 && bodypart != 'Other') {
                  this.bodyside = [];
                  // this.bodysideempty= true
                  return;
                }
                for (let i = 0; i < f2.length; i++) {
                  let te;
                  if (bodypart == 'Hip and Femur Fracture (SHFFT)' && f2[i].includes('Hip and Femur Fracture (SHFFT)')) {
                    f2[i] = f2[i].replace('(SHFFT)', "")
                  }
                  te = f2[i].split('(');
                  te[1] = te[1].replace(')', "")
                  te[1] = te[1].replace(/\s/g, "");
                  te[0] = te[0].replace(/\s/g, "");
                  f2[i] = te
                  if (bodypart.replace(/\s/g, "") == te[0] || te[0] == 'HipandFemurFracture') {
                    if (te[1] == 'Left') {
                      if (bodypart.replace(/\s/g, "") != 'TotalShoulderReplacement')
                        this.bodyside = ['Right']
                      return
                    }
                    else if (te[1] == 'Right') {
                      if (bodypart.replace(/\s/g, "") != 'TotalShoulderReplacement')
                        this.bodyside = ['Left']
                      if (this.bodyl == bodypart) {
                        this.procedureinfo.laterality = this.tempbodylaterality
                        //this.bodyside.push(this.patientinfo.serviceLineLaterality)
                      }
                      return
                    }
                    else if (te[1] == 'Bilateral') {
                      this.temp = false
                      if (this.bodyl == bodypart) {
                        this.procedureinfo.laterality = this.tempbodylaterality
                        this.bodyside = ['Left', 'Right']
                        //this.bodyside.push(this.patientinfo.serviceLineLaterality)
                      }
                      return
                    }
                  }
                }

                if (bodypart == 'T-Spine') {
                  this.procedureinfo.laterality = ''
                  return this.bodyside = []
                } else {
                  this.procedureinfo.laterality = ''
                  return this.bodyside = ['Left', 'Right']
                }







              }
              else {
                this.temp = false

              }
            }

          }
        );
    } else {
      if (this.bodyl != bodypart) {
        if (bodypart == 'T-Spine') {
          this.procedureinfo.laterality = ''
          return this.bodyside = []
        } else {
          this.procedureinfo.laterality = ''
          return this.bodyside = ['Left', 'Right']
        }
      }
    }

  }


  checkempty1(id) {
    let date
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    let newDate = new Date()
    let curentdate = this.datepipe.transform(newDate, 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild1 = true;
      this.mindate = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date <= "1800-01-01") {
      this.mindate = true;
      this.showinvaild1 = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date > curentdate) {
      this.maxdate = true;
      this.showinvaild1 = false;
      this.mindate = false;
    } else {
      this.showinvaild1 = false;
      this.mindate = false;
      this.maxdate = false;
    }

  }


  checkemp(id) {
    let date
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    this.mindate1 = new Date(this.mindate1)
    let curentdate = this.datepipe.transform(this.mindate1, 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = false;
      this.format = true
    } else if (id != '' && id != null && date < curentdate) {
      this.showinvaild = true;
      this.format = false
    } else {
      this.showinvaild = false;
      this.format = false
    }

  }


  checkemail(userdetails) {
    let self = this;
    if (self.temMail == self.patientinfo.email) {
      self.emailcheck = false
      return;
    }
    else {
      self.patientservice.getBundleEmailExists(self.patientinfo.email, self.patientinfo.bundlePatientId)
        .subscribe(data => {
          if (data) {
            self.emailcheck = true
            this.userService.getuserdetails(self.patientinfo.email)
              .subscribe(
                data => {
                  if (data) {
                    this.userinfo = data
                    if (((!this.patientinfo.firstName && !this.patientinfo.lastName && !this.patientinfo.email) || (data.firstName != this.patientinfo.firstName) && (data.lastName != this.patientinfo.lastName))) {
                      this.modalRef1 = this.modalService.show(userdetails, {
                        class: 'modal-md',
                        backdrop: 'static'
                      })
                      this.movable();
                    }
                  }
                })
          }
        })
    }

  }

  calculateBMI(weight, height, inch) {
    let self = this;
    weight = parseFloat(weight);
    height = parseInt(height);
    inch = parseInt(inch);

    weight = weight * 0.453592;
    height = (((height * 12) + inch) * .0254);
    let bmi = weight / Math.pow(height, 2.0);
    self.patientdetail.bmi = bmi.toFixed(2)
  }



  fileUpload(event) {
    let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (events: any) => {
      if (!acceptFormat.includes(event.target.files[0].type)) {
        this.toast.error(this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'), '', {
          timeOut: this.timealert
        })
        this.myInputVariable.nativeElement.value = "";
        this.dataimg = this.defaultUl;
        return;
      }
      if (event.target.files[0].size > this.imgMaxSize) {
        this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
          timeOut: this.timealert
        })
        this.myInputVariable.nativeElement.value = "";
        this.dataimg = this.defaultUl;
        return;
      } else {
        this.dataimg = events.currentTarget.result;
        this.imagearr = {
          filename: event.target.files[0].name,
          filetype: event.target.files[0].type,
          value: events.currentTarget.result.split(',')[1]
        };
      }

    }
  }



  getBpci(dob) {


    let diff_ms = Date.now() - dob.getTime();
    //let diff_ms = Date.now();
    let age_dt = new Date(diff_ms);

    let age = Math.abs(age_dt.getUTCFullYear() - 1970);
    if (age >= 65) {
      return 'Yes';
    }
    if (age < 65) {
      return 'No'
    }
  }


  checknull(id) {
    var d = new Date(id);
    var timeDiff = Math.ceil(d.getTime() - this.dosMaxDate.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    if ((this.dosvalue != '' && id == '') || id == null || id == 'Invalid Date') {
      this.showin = true
      ////console.log("true")
    } else if ((this.dosvalue == '' || id != '') && id != null) {
      this.showin = false
      ////console.log("false")
    }

    if (diffDays > 0) {

      this.patientinfo.dos = '';
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.invalid_date.error'), '', {
        timeOut: this.timealert
      })
      return;

    }

  }
  checkForm(f: NgForm) {
    //////console.log("f",f)
  }

  setMRNnull(event) {
    let self = this;
    if (self.patientinfo.mrn) {
      self.patientinfo.mrn = '';
    }
  }

  setssnnull(event) {
    let self = this;
    if (self.patientinfo.ssn) {
      self.patientinfo.ssn = ''
    }
  }




  validateEmail(email) {

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());

  }


  note(e) {

    this.emailstatus = this.validateEmail(this.patientinfo.email)
    if (!this.emailstatus && this.patientinfo.email != "") {
      this.patientinfo.email = ""
      this.validatemail = true
      /* this.toast.error("Enter valid email address", '', {
        timeOut: this.timealert
      }) */
    } else {
      this.validatemail = false
    }

    if ((this.patientStatus == 'Falling Behind') || (this.patientStatus == 'On Track' || this.patientStatus == 'Up to speed')) {
      this.invited = false;
      if (!this.procedureinfo.email && !this.procedureinfo.phone) {
        this.required = true
      }
      else if (this.procedureinfo.email && this.procedureinfo.phone) {

        this.required = false
      }
      else if (!this.procedureinfo.email) {

        this.required = false
      }
      else if (!this.procedureinfo.phone) {

        this.required = false
      }

    }
    else if (this.patientStatus == 'Invited') {
      if (!this.procedureinfo.email && !this.procedureinfo.phone) {
        this.invited = true
      }
      else if (this.procedureinfo.email && this.procedureinfo.phone) {

        this.invited = false
      }
      else if (!this.procedureinfo.email) {

        this.invited = false
      }
      else if (!this.procedureinfo.phone) {

        this.invited = false
      }

    }
    this.show = e;
    // ////console.log("event", e)
    if (e == this.procedureinfo.email) {
      this.status = true;
    }
    else if (e != this.procedureinfo.email) {
      this.status = false;
    }
    // ////console.log("status", this.status)
  }
  pho(e) {
    if ((this.patientStatus == 'Falling Behind') || (this.patientStatus == 'On Track' || this.patientStatus == 'Up to speed')) {
      if (!this.procedureinfo.email && !this.procedureinfo.phone) {
        this.required = true
      }
      else if (this.procedureinfo.email && this.procedureinfo.phone) {

        this.required = false
      }
      else if (!this.procedureinfo.email) {

        this.required = false
      }
      else if (!this.procedureinfo.phone) {

        this.required = false
      }

    }
    else if (this.patientStatus == 'Invited') {
      if (!this.procedureinfo.email && !this.procedureinfo.phone) {
        this.invited = true
      }
      else if (this.procedureinfo.email && this.procedureinfo.phone) {

        this.invited = false
      }
      else if (!this.procedureinfo.email) {

        this.invited = false
      }
      else if (!this.procedureinfo.phone) {

        this.invited = false
      }

    }
    this.showph = e;
    // ////console.log("event", e)
    if (e == this.procedureinfo.phone) {
      this.mobile = true
    }
    else if (e != this.procedureinfo.phone) {
      this.mobile = false
    }
  }

  editpatient(ed, temppassword) {
    ////console.log(this.patientinfo)
    this.validatemail = false
    this.showloader = true;
    this.patientinfo.updateimage = this.imagearr;
    if (this.imagearr == undefined) {
      this.patientinfo.updateimage = {};
    }
    if (this.patientinfo.dob)
      this.patientinfo.dob = this.datepipe.transform(this.patientinfo.dob, 'yyyy-MM-dd');
    if (this.procedureinfo.dos)
      this.procedureinfo.dos = this.datepipe.transform(this.procedureinfo.dos, 'yyyy-MM-dd');
    // ////console.log(this.patientinfo);

    if (this.patientinfo.telNumber) {
      let telCode
      telCode = this.patientinfo.code.split(',')
      this.patientinfo.telCode = telCode[0]
      this.patientinfo.telCountryCode = telCode[1]
    } else {
      this.patientinfo.code = ''
      this.patientinfo.telCode = ''
      this.patientinfo.telCountryCode = ''
    }
    if (this.patientinfo.phoneOther) {
      let telCode
      telCode = this.patientinfo.codeOther.split(',')
      this.patientinfo.telCodeOther = telCode[0]
      this.patientinfo.telCountryCodeOther = telCode[1]
    } else {
      this.patientinfo.codeOther = ''
      this.patientinfo.telCodeOther = ''
      this.patientinfo.telCountryCodeOther = ''
    }



    if (this.procedureinfo.procedureType == 'Partial Hip Replacement' || this.procedureinfo.procedureType == 'Hip and Femur Fracture (SHFFT)') {
      this.procedureinfo.fracture = true
      this.fracs = this.procedureinfo.fracture
    }

    // ////console.log(pr.value)"T-Spine"
    if (this.procedureinfo.procedureType == 'Lumbar Fusion' || this.procedureinfo.procedureType == 'T-Spine' || this.procedureinfo.procedureType == 'Lumbar Laminectomy') {
      this.procedureinfo.laterality = 'Back'
    } else if (this.procedureinfo.procedureType == 'Cervical Fusion' || this.procedureinfo.procedureType == 'Cervical Laminectomy') {
      this.procedureinfo.laterality = 'Neck'

    }
    if (!this.procedureinfo.hospitalId)
      this.procedureinfo.hospitalId = ''
    if (!this.procedureinfo.Other)
      this.procedureinfo.Other = ''
    if (!this.procedureinfo.Other)
      this.procedureinfo.Other = ''
    this.Totaldata = {
      "bundlePatientId": this.params.patientId,
      "loginUserAccountId": this.currentUser.item.userAccountId,
      "enrollPatientId": this.enrollPatientId,
      "payorData": {
        "bundlePayorType": "",
        "bundlePayorTypeId": this.payorinfo.bundlePayorTypeId,
        "plan": this.payorinfo.plan,
        "tssContact": this.payorinfo.tssContact
      },
      "procedureData": {
        "dos": this.procedureinfo.dos,
        "fracture": this.procedureinfo.fracture,
        "hospitalId": this.procedureinfo.hospitalId,
        "laterality": this.procedureinfo.laterality,
        "otherServicelineLabel": this.procedureinfo.otherServicelineLabel,
        "procedureType": this.procedureinfo.procedureType,
        "surgeonId": this.procedureinfo.surgeonId,
        "surgeonName": this.procedureinfo.surgeonName,
        "surgicalLocation": this.procedureinfo.surgicalLocation
      },
      "profileData": {
        "age": this.patientinfo.age,
        "dob": this.patientinfo.dob,
        "email": this.patientinfo.email,
        "firstName": this.patientinfo.firstName,
        "gender": this.patientinfo.gender,
        "image": "",
        "lastName": this.patientinfo.lastName,
        "mrn": this.patientinfo.mrn,
        "qualificationStatus": this.patientinfo.qualificationStatus,
        "ssn": this.patientinfo.ssn,
        "stage": this.patientinfo.stage,
        "telCode": this.patientinfo.telCode,
        "telCountryCode": this.patientinfo.telCountryCode,
        "telNumber": this.patientinfo.telNumber,
        "otherPhoneType": this.patientinfo.otherPhoneType ? this.patientinfo.otherPhoneType : 1,
        "telCodeOther": this.patientinfo.telCodeOther,
        "telCountryCodeOther": this.patientinfo.telCountryCodeOther,
        "phoneOther": this.patientinfo.phoneOther ? this.patientinfo.phoneOther : ''
      },
      "uploadImage": this.patientinfo.updateimage,
      "stageId": parseInt(this.patdetails.stageId),
      "qualificationId": parseInt(this.patdetails.qualificationId)
    }
    this.patientservice.patdas(this.Totaldata)
      .subscribe(
        data => {
          this.showloader = false;
          if (data.status && this.patdetails.qualificationId != 14) {
            this.respass = this.userService.translateText('patient_portal.display_messages.update_message');
            this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: "static" });
            this.movable()
            this.resp = " ";
            this.stage = ''
            this.qualificationId = ''
            this.route.navigate([`/care/patsummaryinfo/${this.params.patientId}/${this.patdetails.stageId}/${this.patdetails.qualificationId}`])
          } else if (data.status && this.patdetails.qualificationId == 14) {
            this.submitenrolled(this.Totaldata)
          }
          else {
            this.resp = this.userService.translateText('hospital_portal.qualification_lst.something_went_wrong.error');
          }
        }

      );

  }
  submitenrolled(roll) {
    this.showloader = true;
    let datevalue = this.datepipe.transform(roll.procedureData.dos, 'yyyy-MM-dd');
    if (!roll.notesenroll) {
      roll.notesenroll = ''
    }
    let index = _.findIndex(this.hospitalList, (o: any): any => {
      return o.hospitalId == roll.procedureData.hospitalId
    })
    var enroll = {
      "dos": datevalue,
      "hospitalId": roll.procedureData.hospitalId,
      "hospitalName": this.hospitalList[index].name,
      "notes": roll.notesenroll
    }
    ////console.log(enroll, "enroll")
    this.patientservice
      .updateEnroll(roll.bundlePatientId, this.currentUser.item.userAccountId, enroll)
      .subscribe(
        data => {
          if (data) {
            this.showloader = false;
            this.toast.success(this.userService.translateText('hospital_portal.qualification_lst.enrolled.success'), '', {
              timeOut: this.timealert
            })
            this.userService.logAudit('enrollPatient', roll.bundlePatientId).subscribe(data => { })
            // this.dataGrid.instance.cancelEditData();
            this.headerqualificationcount()
            this.route.navigate([`/care/patientlist`])
          }
          else {
            this.showloader = false;
            // this.enableenroll = false
            this.toast.error(this.userService.translateText('hospital_portal.qualification_lst.failed_to_save.error'))
          }
        }

      );
  }
  headerqualificationcount() {
    this.patientservice.getcountqual('Default', this.currentUser.item.userAccountId, this.currentUser.item.selectCNUserId).subscribe(
      data => {
        if (data)
          this.currentUser.item.pqtlength = parseInt(data.Count)
      }
    )
  }
  close() {
    this.modalRef1.hide();
    this.openpopup = false;
  }
  mailclose() {
    this.modalRef1.hide();
    this.patientservice
      .getpatientdetails(this.params.patientId)
      .subscribe(
        data => {
          for (var i = 0; i < data.length; i++) {
            this.patientdetail = data[i];
            this.temMail = data[i].email;
            if (this.patientdetail.telCode || this.patientdetail.telCode != '') {
              this.patientdetail.code = this.patientdetail.telCode + ',' + this.patientdetail.telCountryCode
            }
            else {
              if (this.currentUser.item.language != 'en_uk') {
                this.patientdetail.code = '+1,USA'
              } else if (this.currentUser.item.language == 'en_uk') {
                this.patientdetail.code = '+44,UK'
              }
              if (this.currentUser.item.clientTeleCode)
                this.patientdetail.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
            }
            // ////console.log("code", this.patientdetail.code);
          }
          this.dataimg = this.imageURL + data[0].Imagepath;
          // ////console.log("email", this.patientdetail.email);

        }

      );
  }




  dateValueChange(event) {
    if (event.inputType != 'deleteContentBackward') {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }

  checkempty(id) {
    // ////console.log(id)
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = true
    } else if (id != '' && id != null) {
      this.showinvaild = false
    }
  }

  check1(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital1 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital1 = false
      // ////console.log("false")
    }

  }

  check2(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital2 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital2 = false
      // ////console.log("false")
    }

  }
  check3(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital3 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital3 = false
      // ////console.log("false")
    }

  }
  check4(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital4 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital4 = false
      // ////console.log("false")
    }

  }
  check5(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital5 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital5 = false
      // ////console.log("false")
    }

  }
  check6(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital6 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital6 = false
      // ////console.log("false")
    }

  }
  check7(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital7 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital7 = false
      // ////console.log("false")
    }

  }
  check8(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital8 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital8 = false
      // ////console.log("false")
    }

  }
  changeTab(e) {
    this.Notes = e;
    if (e == 'Notes') {
      this.Noteslist()
    }
    if (e == 'Qualification') {
      this.QualificationNoteslist()
    }
  }

  checked(value) {
    this.hiddenchecked = true;
    if (value) {
      this.showcross = true;
    }

  }
  clearBodyPart(i) {
    let self = this;
    self.patientdetail.location = ''
    self.patientdetail.laterality = ''
  }
  getBodyParts(event) {

    if (event == "Shoulder") {
      this.bodyparttype = true;
    } else {
      this.bodyparttype = false;
    }
  }

  openModel(confirm: TemplateRef<any>, emp) {
    let self = this;
    this.modalRef = self.modalService.show(confirm, { class: 'modal-md', backdrop: 'static' })
    this.movable()
  }
  Noteslist() {
    this.patientservice
      .getNotesList(this.params.patientId)
      .subscribe(
        data => {
          this.notesmsg = data;
          ////console.log(this.notesmsg)
          if (this.notesmsg.length > 0) {
            let last: any = this.notesmsg[this.notesmsg.length - 1];
            ////console.log(last);
            this.msg.title = last.title;
            this.msg.comment = last.comments;
          }
        }

      );
  }
  QualificationNoteslist() {
    this.patientservice
      .getQNotesList(this.params.patientId)
      .subscribe(
        data => {
          this.Qnote = data.notes;

        }

      );
  }
  submitmsg(msg) {
    ////console.log(msg.value)
    let comments = {
      "bundlePatientId": this.params.patientId,
      "notesComments": msg.value.comment,
      "notesCreatedBy": this.currentUser.item.userAccountId,
      "notesTitle": msg.value.title
    }
    ////console.log(comments)
    this.patientservice
      .savecomment(comments)
      .subscribe(
        data => {
          ////console.log(data, "empty")

          this.toast.success(this.userService.translateText('patient_portal.display_messages.saved_successfully'))
          this.userService.logAudit('saveBundleNotes', this.params.patientId).subscribe(data => { })
          this.modalRef.hide()
          this.Noteslist()
        }

      );

  }
  getbundlepayortypeprocedure(id) {
    let self = this;
    self.patientservice.getBundlepartType(this.currentUser.item.userAccountKey, id).subscribe(
      data => {
        this.payortypechange = data
        ////console.log(this.payortypechange)
        let index = _.findIndex(self.payortypechange, (o: any): any => {
          return o.ProcedureName == self.procedureinfo.procedureType
        })
        if (index == -1) {
          this.procedureinfo.surgicalLocation = ''
          this.procedureinfo.procedureType = ''
          this.procedureinfo.laterality = '';
          this.procedureinfo.hospitalId = '';
          this.procedureinfo.surgeonId = '';
          this.procedureinfo.fracture = false
          this.enabletext = true
        }
        this.bodysurgical = [];
        this.patientservice.getSurgicalLocation(this.currentUser.item.userAccountKey, id).subscribe(data => {
          this.bodysurgical = data
        })
        let surgeonId = this.procedureinfo.surgeonId ? this.procedureinfo.surgeonId : 0
        this.patientservice.getHospitalListbyPayor(id, this.currentUser.item.userAccountKey, surgeonId).subscribe(data => {
          self.hospitalList = _.filter(data, (o) => {
            return o.hospitalId != 500000
          })
          const selectElement = document.getElementById("sos") as any;
          const selectedValue = this.procedureinfo.hospitalId;
          setTimeout(() => {
            for (let option of selectElement.options) {
              if (option.value == selectedValue) {
                option.selected = true;
              }
            }
          }, 250);
        })
      }
    )
  }

  formSurgeonIdChange(event) {
    if (event && this.payorinfo.bundlePayorTypeId) {
      this.procedureinfo.hospitalId = ""
      let surgeonId = this.procedureinfo.surgeonId ? this.procedureinfo.surgeonId : 0
      this.patientservice.getHospitalListbyPayor(this.payorinfo.bundlePayorTypeId, this.currentUser.item.userAccountKey, surgeonId).subscribe(data => {
        this.hospitalList = _.filter(data, (o) => {
          return o.hospitalId != 500000
        })
      })
    }
  }
  checkphonelength(e) {
    if (e) {
      if (this.temphone != this.patientinfo.telNumber)
        this.patientinfo.telNumber = "";
      let telecode = e.split(',')
      let codecoun = telecode[1]
      this.userService.phonebycountrycode(codecoun)
        .subscribe(
          data => {
            this.setlength = data.Length;
            this.maxlen = data.Length + this.currentUser.item.length;
            if (data.Length == 11) {
              this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
            } else {
              this.setmask = this.currentUser.item.phoneFormat.split('#').join('0')
            }
          }
        );
    }
  }
  checkphonelength1(e) {
    if (e) {
      if (this.temphoneOther != this.patientinfo.phoneOther)
        this.patientinfo.phoneOther = "";
      let telecode = e.split(',')
      let codecoun = telecode[1]
      this.userService.phonebycountrycode(codecoun)
        .subscribe(
          data => {
            this.setlength1 = data.Length;
            this.maxlen1 = data.Length + this.currentUser.item.length;
            if (data.Length == 11) {
              this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
            } else {
              this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0')
            }
          }
        );
    }
  }

  checkphonlength1(e) {
    if (e) {
      let code = this.patientinfo.code.split(',')
      let codeOther = this.patientinfo.codeOther.split(',')
      if (code[0] + this.patientinfo.telNumber == codeOther[0] + this.patientinfo.phoneOther && this.patientinfo.telNumber) {
        this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
          timeOut: this.timealert
        })
        return this.patientdetail.phoneOther = ''
      }
    }

  }
  checkphonlength(userdetails) {
    let code = this.patientinfo.code.split(',')
    let codeOther = this.patientinfo.codeOther.split(',')
    if (code[0] + this.patientinfo.telNumber == codeOther[0] + this.patientinfo.phoneOther && this.patientinfo.phoneOther) {
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
        timeOut: this.timealert
      })
      return this.patientinfo.telNumber = ''
    } else {
      if (userdetails)
        this.onSelection1(userdetails)
    }

  }
  userinfo: any;
  onSelection1(userdetails) {
    let code = this.patientinfo.code.split(',')
    let phone = code[0] + '-' + this.patientinfo.telNumber
    this.patientservice.chenckPatientPhoneExists(phone, this.currentUser.item.userAccountKey)
      .subscribe(data => {
        if (data) {
          this.userService.getuserdetails(phone)
            .subscribe(
              data => {
                if (data) {
                  this.userinfo = data
                  if (((!this.patientinfo.firstName && !this.patientinfo.lastName && !this.patientinfo.email) || (data.firstName != this.patientinfo.firstName) && (data.lastName != this.patientinfo.lastName) && (data.email != this.patientinfo.email))) {
                    this.modalRef1 = this.modalService.show(userdetails, {
                      class: 'modal-md',
                      backdrop: 'static'
                    })
                    this.movable();
                  }
                }
              })
        }
      })


  }
  disqualifipat(templatedel: TemplateRef<any>, patdata) {
    if (patdata.qualificationId == 3 || patdata.qualificationId == 8 || patdata.qualificationId == 12 || patdata.qualificationId == 17 || patdata.qualificationId == 18) {
      this.patdetail = patdata
      this.patdata = patdata
      this.patdisqualifi.stageId = patdata.stageId
      this.patdisqualifi.reasonId = ''
      this.changestage(patdata.stageId)
      this.modalRef = this.modalService.show(templatedel, { class: 'modal-lg', backdrop: "static" });
      this.movable()
    }

  }
  getdisabled(qualificationId) {
    if (qualificationId == 3 || qualificationId == 8 || qualificationId == 12 || qualificationId == 17 || qualificationId == 18 || qualificationId == 21) {
      return true
    } else {
      return false
    }
  }
  changestage(event) {
    if (event == 1) {
      this.patdisqualifi.qualificationId = 3
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 2) {
      this.patdisqualifi.qualificationId = 18
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 3) {
      this.patdisqualifi.qualificationId = 8
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 4) {
      this.patdisqualifi.qualificationId = 12
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 6) {
      this.patdisqualifi.qualificationId = 17
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    }

  }
  statuss(value) {
    ////console.log(value)
    this.disresult = value
  }
  disqualifipatient(data) {
    if (this.patdisqualifi && this.patdata) {
      if (!data.value.notes) {
        data.value.notes = ''
      }
      if (!data.value.other) {
        data.value.other = ''
      }
      let disqualifi = {
        bundlePatientId: this.params.patientId,
        loginUserId: this.currentUser.item.userAccountId,
        notes: this.patdisqualifi.notes,
        qualificationId: this.patdisqualifi.qualificationId,
        reasonId: this.patdisqualifi.reasonId,
        reportToCCN: this.disresult,
        other: this.patdisqualifi.other,
        stageId: this.patdisqualifi.stageId
      }
      this.patientservice
        .postdisqualifi(disqualifi)
        .subscribe(
          data => {
            if (data) {
              this.toast.success(this.userService.translateText('hospital_portal.qualification_lst.patient_disqualified.success'), '', {
                timeOut: this.timealert
              })
              this.userService.logAudit('disQualifyPatient', this.params.patientId).subscribe(data => { })
              this.modalRef.hide()
              this.patdisqualifi = {}
              this.ngOnInit();
            }
            else {
              this.toast.error(this.userService.translateText('patient_portal.display_messages.invalid_data.error'), '', {
                timeOut: this.timealert
              })
            }
          }

        );
    }
  }

  ngOnDestroy() {
    this.patientinfo = {};
    this.payorinfo = {};
    this.procedureinfo = {};
    console.log("Sdas")
  }

  reasonstage() {
    this.patientservice
      .getReasonCodeDetailsList()
      .subscribe(
        data => {
          this.reason = data;
        }

      );
  }
  getdate(date) {
    if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.datepipe.transform(date, environment.dateForm);
    } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.datepipe.transform(date, 'dd/MM/yyyy');
    }
  }
  getdatetime(date) {
    if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
    } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
    }
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  changeFormatToDate(dateString) {
    var changedFormat;
    if (this.currentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
      var splitDate1 = dateString.split('/');
      if (splitDate1.length > 1) {
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        changedFormat = month1 + "/" + day1 + "/" + year1;
        return changedFormat
      } else {
        var date: any = dateString
        return new Date(date)
      }
    } else {
      return new Date(dateString)
    }
  }

  siteToolTip(id, cond) {
    let returnData: any = "";
    let checkDate;
    if (cond == 1 && this.hospitalList) {
      checkDate = this.hospitalList.filter(it =>
        it.hospitalPracticeid == id)
    }
    // else if(cond==2 && this.facility){
    //   checkDate = this.facility.filter(it => it.hspPracticeId==id 
    //     || it.hospitalPracticeid==id)
    // }
    if (checkDate && checkDate.length != 0)
      returnData = checkDate[0].name


    return returnData;
  }


  //Alternate Phone Number
  viewalterno(phoneOthervalue) {
    if (!phoneOthervalue) {
      this.phoneOthervalue = true
      this.patientinfo.otherPhoneType = 1
      this.changeAlterNo()
    }
  }
  changeAlterNo() {
    if (this.currentUser.item.language != 'en_uk') {
      this.patientinfo.codeOther = '+1,USA'
    } else if (this.currentUser.item.language == 'en_uk') {
      this.patientinfo.codeOther = '+44,UK'
    }
    if (this.currentUser.item.clientTeleCode) {
      this.patientinfo.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
    }
    this.patientinfo.phoneOther = ''
  }
  yesToShowUser(status) {
    if (status) {
      this.modalRef1.hide();
      this.patientinfo.dob = new Date(this.userinfo.DOB);
      if (this.userinfo.imagePath && this.userinfo.imagePath.search("default_") == -1) {
        if (this.currentUser.item) {
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
        this.patientUrl = this.imageURL + this.userinfo.imagePath;
      }
      this.patientinfo.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
      this.patientinfo.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
      if (this.userinfo.teleCode)
        this.patientinfo.code = this.userinfo.teleCode + ',' + this.userinfo.teleCountryCode;
      if (this.userinfo.teleCodeOther)
        this.patientinfo.codeOther = this.userinfo.teleCodeOther + ',' + this.userinfo.teleCountryCodeOther;
      if (this.userinfo.email)
        this.temMail = this.userinfo.email
      if (this.userinfo.phone)
        this.tempphone = this.userinfo.phone
      this.patientinfo.firstName = this.userinfo.firstName
      this.patientinfo.lastName = this.userinfo.lastName
      this.patientinfo.telNumber = this.userinfo.phone ? this.userinfo.phone : ''
      this.patientinfo.phoneOther = this.userinfo.phoneOther ? this.userinfo.phoneOther : ''
      this.patientinfo.otherPhoneType = this.userinfo.otherPhoneType ? this.userinfo.otherPhoneType : 1
      this.patientinfo.weight = this.userinfo.Weight ? this.userinfo.Weight : 0
      this.patientinfo.height = this.userinfo.Height ? this.userinfo.Height : 0
      this.patientinfo.inch = this.userinfo.Inch ? this.userinfo.Inch : 0
      this.patientinfo.bmi = this.userinfo.BMI ? this.userinfo.BMI : 0
      this.patientinfo.mrnNo = this.userinfo.MRN ? this.userinfo.MRN : ''
      this.patientinfo.hic = this.userinfo.HIC ? this.userinfo.HIC : ''
      this.patientinfo.ssn = this.userinfo.SSN ? this.userinfo.SSN : ''

    } else {
      this.modalRef1.hide();
      this.patientinfo.email = ''
      this.patientinfo.telNumber = ''
      if (this.currentUser.item.language != 'en_uk') {
        this.patientinfo.code = '+1,USA'
      } else if (this.currentUser.item.language == 'en_uk') {
        this.patientinfo.code = '+44,UK'
      }
    }
  }
  downloadBundleHis() {
    let data: any = {
      'type': this.Notes,
      'bundlePatientId': this.params.patientId,
      'preview': false,
      'loginUserId': this.uid,
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    location.href = this.apiurl + '/pages/downloadBundleHistory.xhtml?dvalue=' + data
  }

  getSide(side) {   //for display side in multilanguage
		if(side == 'Left') {
		  return this.userService.translateText('hospital_portal.body_part.left.label')
		} else if(side == 'Right') {
		  return this.userService.translateText('hospital_portal.body_part.right.label')
		} else if(side == 'Bilateral') {
		  return this.userService.translateText('hospital_portal.body_part.bilateral.label')
		}
	}
}
